import { NavLink, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import QrModal from './QrModal';
import { useAuth } from '../hooks/useAuth';
import { useRecoilState } from 'recoil';
import { qrModalState } from '../states/atoms';
import { FirebaseBrain } from '../services/FirebaseBrain/FirebaseBrain';
import { FirebaseWebScreens, FirebaseQrSource } from '../services/FirebaseBrain/FirebaseBrainScreens';

const MainMenu = () => {
  const { t } = useTranslation();
  const [qrModal, setQrModal] = useRecoilState(qrModalState);
  const { isAuthenticated } = useAuth();
  const history = useHistory();

  return (
    <>
      <aside className='main-menu'>
        <div className='main-menu__container'>
          <nav className='main-menu__navigation navigation'>
            <ul className='navigation__list'>
              <li className='navigation__item'>
                <NavLink
                  to='/'
                  exact
                  className='navigation__link navigation__link--periodic-table'
                  activeClassName='navigation__link--current navigation__link--current--pt'
                  onClick={() => FirebaseBrain.webMenuClick(FirebaseWebScreens.MENU_PERIODIC_TABLE)}
                />
              </li>
              <li className='navigation__item'>
                <NavLink
                  exact
                  to='/search'
                  className='navigation__link navigation__link--search'
                  activeClassName='navigation__link--current navigation__link--current--search'
                  onClick={() => FirebaseBrain.webMenuClick(FirebaseWebScreens.MENU_SEARCH)}
                >
                  {t('string.translate.menu_tab2')}
                </NavLink>
              </li>
              <li className='navigation__item'>
                <NavLink
                  to='/element-list'
                  className='navigation__link navigation__link--list'
                  activeClassName='navigation__link--current navigation__link--current--list'
                  onClick={() => FirebaseBrain.webMenuClick(FirebaseWebScreens.MENU_ELEMENT_LIST)}
                >
                  {t('string.translate.menu_tab3')}
                </NavLink>
              </li>
              <li className='navigation__item'>
                <NavLink
                  exact
                  to='/tables'
                  className='navigation__link navigation__link--tables'
                  activeClassName='navigation__link--current navigation__link--current--tables'
                  onClick={() => FirebaseBrain.webMenuClick(FirebaseWebScreens.MENU_TABLES)}
                >
                  {t('string.translate.menu_tab4')}
                </NavLink>
              </li>
              <li className='navigation__item'>
                {isAuthenticated ? <NavLink
                    exact
                    to='/calculators'
                    className='navigation__link navigation__link--calculator'
                    activeClassName='navigation__link--current navigation__link--current--calculator'
                    onClick={() => FirebaseBrain.webMenuClick(FirebaseWebScreens.MENU_CALCULATORS)}
                  >
                    {t('calc.translate.calc_list_activity_name')}
                  </NavLink> :
                  <button className='navigation__link navigation__link--calculator' onClick={() => {
                    FirebaseBrain.qrModalOpen(FirebaseQrSource.MENU_CALCULATORS);
                    setQrModal(!qrModal);
                    history.push('/');
                  }} />}
              </li>
              <li className='navigation__item navigation__item--settings'>
                <NavLink
                  exact
                  to='/settings'
                  className='navigation__link navigation__link--settings'
                  activeClassName='navigation__link--current navigation__link--current--settings'
                  onClick={() => FirebaseBrain.webMenuClick(FirebaseWebScreens.MENU_SETTINGS)}
                />
              </li>
              {!isAuthenticated && <li className='navigation__link navigation__link--qr'>
                <button className='qr-modal__qr-button' onClick={() => {
                  FirebaseBrain.qrModalOpen(FirebaseQrSource.MENU_QR_BUTTON);
                  setQrModal(!qrModal);
                  history.push('/');
                }} />
              </li>}
            </ul>
          </nav>
        </div>
      </aside>
      {qrModal && <QrModal onClick={() => setQrModal(!qrModal)} />}
    </>
  );
};

export default MainMenu;